export default __webpack_public_path__ + "static/media/finances.85d5fdab.svg";